import * as React from 'react';

import { useDispatch } from 'react-redux';

import { PaywallScreens } from '~analytics/types';
import { openPaywall } from '~teacher/slices/teacher/teacherSlice';

export function useDisplayPaywall() {
  const dispatch = useDispatch();
  const [paywalls, setPaywall] = React.useState<Set<PaywallScreens>>(new Set());

  const displayPaywall = React.useCallback(
    (paywallScreen: PaywallScreens) => {
      if (paywalls.has(paywallScreen)) {
        return;
      }
      dispatch(openPaywall({ paywallTouch: [paywallScreen] }));
      setPaywall(new Set(paywalls.add(paywallScreen)));
    },
    [paywalls, dispatch, openPaywall]
  );

  return { paywalls, displayPaywall };
}
